import React from 'react';

export default function ButtonArea({ children }) {
	return <div className="button-area">
		{children}
	</div>;
}